<template>
  <modal size="md" modal-id="signature-modal" show-on-mount @closed="$emit('modal-closed')">
    <template #body>
      <event-cancelled-notice v-if="eventStatus.cancelled" />
      <host-notice v-else-if="eventStatus.currentUserIsHost" />
      <rsvped-notice v-else-if="attendeeHasRsvped" />
      <full-notice v-else-if="eventStatus.full" />
      <open-rsvp v-else :render-form-anchor="false" />
    </template>
  </modal>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import EventCancelledNotice from './event-cancelled-notice'
import FullNotice from './full-notice'
import HostNotice from './host-notice'
import Modal from '@/components/modal'
import OpenRsvp from './open-rsvp'
import RsvpedNotice from './rsvped-notice'

export default {
  components: { EventCancelledNotice, FullNotice, HostNotice, Modal, OpenRsvp, RsvpedNotice },

  emits: ['modal-closed'],

  computed: {
    ...mapState(['eventStatus']),
    ...mapGetters(['attendeeHasRsvped'])
  }
}
</script>

<style lang="scss" scoped>
::v-deep(.sidebar-content) {
  padding: 0;
}
</style>
